import React from "react";
import "./achievement.css";
import { data } from "./achievement_data";

// import Swiper core and required modules
import { Navigation, Pagination } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const Achievements = () => {
  return (
    <section id="achievements">
      <h5>My Achievements</h5>
      <h2>Accomplishments</h2>
      <Swiper
       modules={[Navigation, Pagination]}
       spaceBetween={40}
       slidesPerView={1}
       navigation
       pagination={{ clickable: true }}
        className="container achievements__container"
      >
        {data.map(({ imagelink, award, details, issuer }, index) => {
          return (
            <SwiperSlide key={index} className="achievement">
              <div className="award__image">
                <img src={imagelink} alt="award" />
              </div>
              <div className="award__name">{award}</div>
              <h6 style={{fontStyle:'italic'}}>{issuer}</h6>
              <small className="award__details">{details}</small>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Achievements;
